<template>
  <div>
    <div
      class="banner-overlay"
      style="z-index: 99999999"
      v-if="mensagemHomePromo2 && retornaSite() == '7live'"
      @click="fecharPromo2()"
    >
      <div class="banner-content">
        <div class="mb-2">
          <button type="button" class="btn btn-primary" @click="fecharPromo2()">
            Fechar
          </button>
        </div>
        <div>
          <img src="/assets/promo2.jpeg" alt="Imagem" />
        </div>
      </div>
    </div>
    <div class="row justify-content-md-center" v-if="mensagemHomeVencimento1">
      <div class="col-md-8 text-center text-danger">
        <div
          class="alert alert-success alert-dismissible fade show"
          role="alert"
          v-if="retornaSite() == '7live' && false"
          style=""
        >
          <p class="" style="margin-top: 20px">
            <b>World Cup Promotion</b>
          </p>
          <p class="" style="margin-top: 1rem">
            Enter the chat for more information
          </p>
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
            @click="fecharMensagemHomeVencimento2()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div
          class="alert alert-warning alert-dismissible fade show"
          role="alert"
          v-if="retornaSite() == '7liveHide'"
          style=""
        >
          <p style="margin-top: 1rem;">
            In order to better serve you, we are including the CRYPTO USDT
            deposit system using the Binance Smart Chain network.
          </p>
          <p>We are available for clarification and doubts through our chat.</p>
          <p>Good games everyone!!</p>
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
            @click="fecharMensagemHomeVencimento1()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>

    <div v-if="retornaSite() == 'Stream1x2'">
      <div
        class="row"
        style="margin-bottom: 20px"
        v-if="
          retornaTipoUsuario() == 'Assinante' &&
          planoAtivo &&
          planoDias > -1 &&
          planoDias < 5
        "
      >
        <div class="col-md-12 text-center text-danger">
          <h5 v-if="planoDias == 0">
            <small
              >Hoje é o último dia do seu plano, entre em contato para
              renovar</small
            >
          </h5>
          <h5 v-if="planoDias > 0">
            <small>Seu plano vence em {{ planoDias + 1 }} dias</small>
          </h5>
        </div>
      </div>

      <div
        class="row"
        style="margin-bottom: 20px"
        v-if="
          retornaTipoUsuario() == 'Assinante' &&
          planoAtivo &&
          planoDias >= 5 &&
          vencimento !== ''
        "
      >
        <div class="col-md-12 text-center">
          <h5>
            <small>Seu plano vence no dia {{ vencimento }}</small>
          </h5>
        </div>
      </div>

      <div
        class="row"
        style="margin-bottom: 20px"
        v-if="retornaTipoUsuario() == 'Assinante' && !planoAtivo"
      >
        <div class="col-md-12 text-center text-danger">
          <h5>
            Você não possuí um plano ativo, entre em contato para adquirir
          </h5>
        </div>
      </div>
    </div>

    <div v-if="retornaSite() == 'Weddbets'">
      <div
        class="row"
        style="margin-bottom: 20px"
        v-if="
          planosAgendados.length == 0 &&
          retornaTipoUsuario() == 'Assinante' &&
          planoAtivo &&
          planoDias > -1 &&
          planoDias < 5
        "
      >
        <div class="col-md-12 text-center text-danger">
          <a class="btn btn-sm btn-success mb-2" href="/pay">
            Renovar +30 dias via PIX
          </a>
          <h5 v-if="planoDias == 0">
            <small
              >Hoje é o último dia do seu plano</small
            >
          </h5>
          <h5 v-if="planoDias > 0">
            <small>Seu plano vence em {{ planoDias + 1 }} dias</small>
          </h5>
        </div>
      </div>

      <div
        class="row"
        style="margin-bottom: 20px"
        v-if="
          planosAgendados.length == 0 &&
          retornaTipoUsuario() == 'Assinante' &&
          planoAtivo &&
          planoDias >= 5 &&
          vencimento !== ''
        "
      >
        <div class="col-md-12 text-center">
          <h5>
            <small>Seu último plano vence no dia {{ vencimento }}</small>
          </h5>
        </div>
      </div>

      <div
        class="row"
        style="margin-bottom: 20px"
        v-if="planosAgendados.length > 0 && retornaTipoUsuario() == 'Assinante'"
      >
        <div class="col-md-12 text-center">
          <h5>
            <small
              >Seu último plano vence no dia
              {{
                formatDate(planosAgendados[planosAgendados.length - 1].dataFim)
              }}</small
            >
          </h5>
        </div>
      </div>

      <div
        class="row"
        style="margin-bottom: 20px"
        v-if="retornaTipoUsuario() == 'Assinante' && !planoAtivo"
      >
        <div class="col-md-12 text-center text-danger">
          <a class="btn btn-sm btn-success mb-2" href="/pay">
            Renovar +30 dias via PIX
          </a>
          <h5>
            Você não possuí um plano ativo
          </h5>
        </div>
      </div>
    </div>

    <div
      class="row"
      style="margin-top: 20px; margin-bottom: 20px"
      v-if="
        retornaSite() == '7live' &&
        carregando == false &&
        retornaTipoUsuario() == 'Assinante' &&
        !planoAtivo
      "
    >
      <div class="col-md-12 text-center text-danger">
        <h5 style="margin-bottom: 20px">Você não possuí um plano ativo</h5>
        <button
          type="button"
          class="btn btn-success"
          @click="adquirirPlanoUsuario()"
        >
          Comprar plano
        </button>
      </div>
    </div>

    <EditPlanoUsuarioPublico
      ref="editPlanoUsuarioPublico"
      @fechar="fecharAdquirirPlano()"
    />
  </div>
</template>

<script>
import EditPlanoUsuarioPublico from "../edits/EditPlanoUsuarioPublico";
import util from "../includes/util.js";

export default {
  name: "HomeVencimento",
  components: { EditPlanoUsuarioPublico },
  props: {
    planoAtivo: { type: Boolean, default: true },
    planoDias: { type: Number, default: 10 },
    vencimento: { type: String, default: "" },
    carregando: { type: Boolean, default: true },
    planosAgendados: { type: Array, default: new Array() },
    mensagemHomeVencimento1: { type: Boolean, default: false },
    mensagemHomePromo2: { type: Boolean, default: false },
  },
  methods: {
    retornaSite() {
      return this.$site;
    },
    formatDate(data) {
      if (data == "-") {
        return data;
      }
      return util.formatDate(data);
    },
    retornaTipoUsuario() {
      return this.$sessao ? this.$sessao.usuario.tipoUsuario : "";
    },
    adquirirPlanoUsuario() {
      this.$refs.editPlanoUsuarioPublico.abrir();
    },
    fecharAdquirirPlano() {
      this.$emit("recarregar");
    },
    fecharMensagemHomeVencimento1() {
      localStorage.setItem("mensagemHomeVencimento1", "true");
    },
    fecharMensagemHomeVencimento2() {
      localStorage.setItem("mensagemHomeVencimento2", "true");
    },
    fecharPromo2() {
      this.mensagemHomePromo2 = false;
      localStorage.setItem("mensagemHomePromo2", "true");
    },
  },
  mounted() {
    try {
      var mensagemHomeVencimento1 = localStorage.getItem(
        "mensagemHomeVencimento1"
      );

      if (this.retornaSite() == "7live" && mensagemHomeVencimento1 == null) {
        this.mensagemHomeVencimento1 = true;
      }
    } catch (e) {
      console.log(e);
    }

    try {
      var mensagemHomeVencimento2 = localStorage.getItem(
        "mensagemHomeVencimento2"
      );

      if (this.retornaSite() == "7live" && mensagemHomeVencimento2 == null) {
        this.mensagemHomeVencimento2 = true;
      }
    } catch (e) {
      console.log(e);
    }

    try {
      var mensagemHomePromo2 = localStorage.getItem("mensagemHomePromo2");

      if (this.retornaSite() == "7live" && mensagemHomePromo2 == null) {
        this.mensagemHomePromo2 = true;
      }
    } catch (e) {
      console.log(e);
    }
  },
};
</script>

<style>
.banner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(
    0,
    0,
    0,
    0.5
  ); /* Define a cor de fundo com transparência */
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}
</style>